import moment from 'moment';
import get from 'lodash/get';
import {useDispatch} from 'react-redux';
import {connect} from 'react-redux';
import {useNavigate} from 'react-router-dom';

import Check from '@mui/icons-material/Check';

import SignupComplete from '../../components/patientSignup/SignupComplete';
import PatientSignupLayout from '../../components/patientSignup/PatientSignupLayout/PatientSignupLayout';

import {useGetAppointmentsQuery} from '../../redux/services/appointmentApi';
import {useGetCurrentPatientQuery} from '../../redux/services/patientApi';
import {useGetProvidersQuery} from '../../redux/services/providerApi';
import {useGetSessionTypesQuery} from '../../redux/services/sessionTypeApi';
import {reset} from '../../redux/reducers/patientSignup';
import {logout} from '../../redux/reducers/auth';
import Typography from "@mui/material/Typography";

const OnboardingCompletedPage = props => {
  const {selectedProviderId, selectedSessionTypeId} = props;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userQuery = useGetCurrentPatientQuery(null);
  const providersQuery = useGetProvidersQuery(
    {providerId: selectedProviderId},
    {skip: !selectedProviderId},
  );
  const appointmentsQuery = useGetAppointmentsQuery({});
  const sessionTypesQuery = useGetSessionTypesQuery(
    {providerId: selectedProviderId},
    {skip: !selectedProviderId}
  );
  const appointment = get(appointmentsQuery, 'data.data[0]', null);
  if (userQuery.error) navigate('/login');
  const childProps = {
    title: 'Congratulations! Booking Successful',
    TitleIcon: Check,
    subtitle: 'We’re looking forward to helping you move your best so you can live your best. Please check your email for any final coordination with your provider.',
    hideBackButton: true,
    date: appointment ? moment(appointment.start_time).format('MM/DD/yyyy') : null,
    time: appointment ? moment(appointment.start_time).format('h:mm a') : null,
    endtime: appointment ? moment(appointment.end_time).format('h:mm a') : null,
    user: get(userQuery, 'data'),
    patientId: userQuery?.data?.id,
    backgroundColor: '#F9F9F9',
    step: null,
    selectedProvider: get(providersQuery, 'data', [])
      .find(p => p.id === selectedProviderId),
    sessionType: get(sessionTypesQuery, 'data', [])
      .find(s => s.id === get(appointment, 'session_type_id', 'none')),
    logout: () => dispatch(logout()),
    reset: () => dispatch(reset()),
    onSubmit: () => navigate('/clients'),
  };
  return (
    <PatientSignupLayout
      {...childProps}
      hasPadding={false}
      showStep={false}
      stepTitle={
        <Typography
          sx={{marginTop: '15px !important', marginBottom: '20px', display: 'block'}}
          variant='extraLarge'
          color='white'
        >
          Congratulations! Booking Successful
        </Typography>
      }
    >
      <SignupComplete {...childProps} />
    </PatientSignupLayout>
  );
};

const mapState = state => ({
  selectedSessionTypeId: get(state, 'patientSignup.sessionTypeId'),
  selectedProviderId: get(state, 'patientSignup.providerId', null),
});

const mapDispatch = dispatch => ({

});

export default connect(mapState,mapDispatch)(OnboardingCompletedPage);
